/* eslint-disable */
let domains = {
  assetLinkurl: 'https://lcts2.ssjlicai.com/market-pcweb/asset'
}
if (process.env.API_DOMAIN === 'dev') {
  domains = {
    assetLinkurl: 'https://lcts2.ssjlicai.com/market-pcweb/asset'
  }
}

if (process.env.API_DOMAIN === 'uat') {
  domains = {
    assetLinkurl: 'https://lcuatweb.ssjlicai.com/market-pcweb/asset'
  }
}

if (process.env.API_DOMAIN === 'prod') {
  domains = {
    assetLinkurl: 'https://lc.ssjlicai.com/asset'
  }
}

export default domains


// WEBPACK FOOTER //
// ./src/utils/assets-link.js